import { action, computed, observable, runInAction } from 'mobx';

import request from '../common/utils/Request';

import { ActivateEmailStatus } from '../types';

class ActivateEmailStore {
  private static _instance: ActivateEmailStore;

  @observable public activateEmailStatus: ActivateEmailStatus = ActivateEmailStatus.NOT_STARTED;

  /**
   * Use ActivateEmailStore.instance to retrieve an instance of this class.
   */
  private constructor() { }

  /**
   * Instance of ActivateEmailStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new ActivateEmailStore();
    }

    return this._instance;
  }

  @computed
  public get instructions(): string {
    switch (this.activateEmailStatus) {
      case ActivateEmailStatus.ACTIVATED:
        return 'Thanks! Your account is now activated.';
      case ActivateEmailStatus.INVALID:
        return 'Looks like your link is broken.';
      default:
        return 'Please wait while we activate your account.';
    }
  }

  /**
   * Send request to server and retrieve a brand new JWT.
   */
  @action
  public activateEmail = async(uid: string, token: string) => {
    this.activateEmailStatus = ActivateEmailStatus.WAITING;
    const jsonData = { uid, token };
    
    try {
      await request.post('/auth/users/activate/', jsonData);
      runInAction(() => this.activateEmailStatus = ActivateEmailStatus.ACTIVATED);
    } catch (err) {
      runInAction(() => this.activateEmailStatus = ActivateEmailStatus.INVALID);
    }
  }
}

export default ActivateEmailStore;
export const activateEmailStore = ActivateEmailStore.instance;


// WEBPACK FOOTER //
// ./src/stores/ActivateEmailStore.ts